import React from 'react';
import { Box, Grid, Stack } from '@mui/material';
import { useEnergy } from '../context/EnergyContext';
import { EnergyLineChart, EnergyPageHeader, MetricTile, ProvenanceNote, SectionCard } from '../components/energy/EnergyUi';

export default function CustomerLoadView() {
  const { model } = useEnergy();
  return (
    <Box>
      <EnergyPageHeader title="Customer Facility Load" subtitle="Demand, consumption, interval peaks, profile context, and site interaction" back />
      <Grid container spacing={2}>
        <Grid item xs={12} lg={4}>
          <Stack spacing={2}>
            <SectionCard title="Current demand">
              <Grid container spacing={1}>
                <Grid item xs={12}><MetricTile label="Active demand" value={model.load.powerKw} unit="kW" accent="#7b1fa2" provenance="Measured" /></Grid>
                <Grid item xs={12}><MetricTile label="Selected period consumption" value={model.load.consumedKwh} measure={model.measures?.energy?.consumedKwh} unit="kWh" accent="#7b1fa2" provenance={model.measures?.energy?.consumedKwh?.sourceKind === 'counter_derived' ? 'Register-derived' : 'Estimated'} /></Grid>
                <Grid item xs={6}><MetricTile label="Interval peak" value={model.load.intervalPeakKw} measure={model.measures?.load?.intervalPeakKw} unit="kW" accent="#ed6c02" /></Grid>
                <Grid item xs={6}><MetricTile label="Billing peak" value={model.load.billingPeakKw} measure={model.measures?.load?.billingPeakKw} unit="kW" accent="#d32f2f" /></Grid>
                <Grid item xs={12}><MetricTile label="Active load profile" value={model.load.profile} accent="#7b1fa2" /></Grid>
              </Grid>
            </SectionCard>
            <SectionCard title="Active demand shaping">
              <MetricTile label="BESS response" value={model.bess.pcsKw} unit="kW" accent="#388e3c" state="Shown as measured PCS response" />
              <ProvenanceNote>The load view uses the same customer-load series consumed by EMS. It does not construct a separate display-only demand curve.</ProvenanceNote>
            </SectionCard>
          </Stack>
        </Grid>
        <Grid item xs={12} lg={8}>
          <Stack spacing={2}>
            <SectionCard title="Demand and site context" subtitle="Load, solar, battery, and grid use a shared time axis">
              <EnergyLineChart series={model.series} fields={[{ key: 'loadKw', label: 'Facility load' }, { key: 'solarKw', label: 'Solar generation' }, { key: 'bessKw', label: 'Battery' }, { key: 'gridKw', label: 'Grid exchange' }]} height={300} />
            </SectionCard>
            <SectionCard title="Configured feeder consistency">
              <Grid container spacing={1}>
                <Grid item xs={6}><MetricTile label="Feeder sum minus main meter" value={model.load.feeders?.feederResidualKw} unit="kW" state={model.load.feeders?.status} /></Grid>
                <Grid item xs={6}><MetricTile label="Reporting configured channels" value={model.load.feeders?.reportingChannelCount} /></Grid>
                {(model.load.feeders?.feeders || []).map(feeder => <Grid item xs={6} key={feeder.feederId}><MetricTile label={feeder.feederId} value={feeder.servedPowerKw} unit="kW" state={feeder.shareStatus} /></Grid>)}
              </Grid>
            </SectionCard>
            <SectionCard title="Demand-window evidence">
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}><MetricTile label="Current" value={model.load.powerKw} unit="kW" /></Grid>
                <Grid item xs={12} sm={4}><MetricTile label="Selected interval peak" value={model.load.intervalPeakKw} measure={model.measures?.load?.intervalPeakKw} unit="kW" /></Grid>
                <Grid item xs={12} sm={4}><MetricTile label="Billing-period peak" value={model.load.billingPeakKw} measure={model.measures?.load?.billingPeakKw} unit="kW" /></Grid>
              </Grid>
            </SectionCard>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
